import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorHandlerService } from '../error-handler.service';
import { AnimationsService } from '../animations.service';
import { environment } from '../../../environments/environment';
import { API } from '../api';
import { AuthService } from 'src/app/security/auth.service';

@Injectable({
  providedIn: 'root'
})
export class RecuperarSenhaService {

  constructor(
    private http: HttpClient,
    private animationsService: AnimationsService,
    private errorHandlerService: ErrorHandlerService,
    private authService: AuthService
  ) { }

  getUsuario(userName): Observable<any> {
    this.animationsService.showProgressBar(true);
    const params: HttpParams = new HttpParams().set('userName', userName);
    return this.http.get(`${environment.baseUrl}${API.usuario.esqueciMinhaSenha}`, { params })
      .pipe(
        tap(() => this.animationsService.showProgressBar(false)),
        catchError(this.errorHandlerService.errorHandler('Usuário não encontrado', []))
      );
  }
  
  enviarEmail(data): Observable<any> { // campos: usuarioId, nome, email, oid, contraSenha-"", senha-"", confirmarSenha="" - string
    return this.http.post(`${environment.baseUrl}${API.usuario.confirmarResetSenha}`, data )
      .pipe(
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar o e-email - ', []))
      );
  }
  
  redefinirSenha(data): Observable<any> { // campos: usuarioId, nome, email, oid, contraSenha, senha, confirmarSenha - string
    return this.http.post(`${environment.baseUrl}${API.usuario.confirmarResetSenha}`, data )
      .pipe(
        catchError(this.errorHandlerService.errorHandler('Falha ao enviar o e-email', []))
      );
  }

}